import { useHydrateAtoms } from "jotai/utils";
import type { Experiments } from "./types";
import { experimentsAtom } from "../../store";

export const useExperiments = (initialExperiments?: Experiments) => {
  const experimentMap = new Map(
    initialExperiments ? Object.entries(initialExperiments) : [],
  );

  useHydrateAtoms([[experimentsAtom, experimentMap]]);
};
